import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import "../styles/UsersegmentPie.css";

const COLORS = ["#22c55e", "#f97316"];

const UserSegmentDonut = ({ selectedRestData }) => {





  
  const thisMonth = selectedRestData[selectedRestData.length - 1]

  
  const data = [
    { name: "New Users", value: thisMonth?.new_users },
    { name: "Repeat Users", value: thisMonth?.repeat_users },
  ];

  const total = thisMonth?.new_users + thisMonth?.repeat_users;

  return (
    <div className="analytics-card">

      <h3 style={{ marginBottom: "10px" }}>User Segmentation</h3>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>

          <Pie
            data={data}
            innerRadius={70}
            outerRadius={110}
            paddingAngle={4}
            dataKey="value"
            label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={index} fill={COLORS[index]} />
            ))}
          </Pie>

          <Tooltip />
          <Legend wrapperStyle={{ color: "#e2e8f0" }} />

          {/* center value */}
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#ffffff"
            style={{ fontSize: "22px", fontWeight: "600" }}
          >
            {total}
          </text>

        </PieChart>
      </ResponsiveContainer>

    </div>
  );
};

export default UserSegmentDonut;